var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.3335C6.25 7.74771 6.58579 8.0835 7 8.0835C7.41421 8.0835 7.75 7.74771 7.75 7.3335L6.25 7.3335ZM7.75 4.66683C7.75 4.25262 7.41421 3.91683 7 3.91683C6.58579 3.91683 6.25 4.25262 6.25 4.66683L7.75 4.66683ZM7.75 7.3335L7.75 4.66683L6.25 4.66683L6.25 7.3335L7.75 7.3335Z",
    fill: "#EE3131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86161 1.46529L7.21516 1.84555L7.86161 1.46529ZM12.7799 9.82631L12.1334 10.2066L12.7799 9.82631ZM1.86594 10.2066L6.78419 1.84555L5.49129 1.08502L0.57304 9.44605L1.86594 10.2066ZM7.21516 1.84555L12.1334 10.2066L13.4263 9.44605L8.50806 1.08502L7.21516 1.84555ZM11.9179 10.5833H2.08142V12.0833H11.9179V10.5833ZM6.78419 1.84555C6.88085 1.68123 7.1185 1.68123 7.21516 1.84555L8.50806 1.08502C7.83142 -0.065265 6.16793 -0.0652608 5.49129 1.08502L6.78419 1.84555ZM0.57304 9.44605C-0.1132 10.6127 0.727945 12.0833 2.08142 12.0833V10.5833C1.88807 10.5833 1.76791 10.3732 1.86594 10.2066L0.57304 9.44605ZM12.1334 10.2066C12.2314 10.3732 12.1113 10.5833 11.9179 10.5833V12.0833C13.2714 12.0833 14.1125 10.6127 13.4263 9.44605L12.1334 10.2066Z",
    fill: "#EE3131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 9.66667C7.18344 9.66667 7.33268 9.51743 7.33268 9.33333C7.33268 9.14924 7.18344 9 6.99935 9C6.81525 9 6.66602 9.14924 6.66602 9.33333C6.66602 9.51743 6.81525 9.66667 6.99935 9.66667Z",
    fill: "#EE3131",
    stroke: "#EE3131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert_triangle.6d821ec1e3d620dc0e707540d767dd8e.svg";
export { ForwardRef as ReactComponent };